// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__1CKG3","reveal":"modal_reveal__3x8Zj","slide_up":"modal_slide_up__3x1DU"};